module.exports = __webpack_public_path__ + "img/wechatpay-qrcode.989b800a.svg";